"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _TextLabel = _interopRequireDefault(require("../Typography/TextLabel"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is a private component to provide the drop down
 * for use with MultiSelect.
 */
var MultiSelectDropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MultiSelectDropdown, _React$Component);

  // @override
  function MultiSelectDropdown(props) {
    var _this;

    _classCallCheck(this, MultiSelectDropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiSelectDropdown).call(this, props));

    _this.handleOnRowClick = function (idClicked) {
      var _this$props = _this.props,
          selectedIds = _this$props.selectedIds,
          onSelectedChange = _this$props.onSelectedChange;

      if ((0, _includes2.default)(selectedIds, idClicked)) {
        // remove
        onSelectedChange(selectedIds.filter(function (id) {
          return id !== idClicked;
        }), idClicked, false);
        return;
      } // add


      onSelectedChange([].concat(_toConsumableArray(selectedIds), [idClicked]), idClicked, true);
    };

    _this.handleMouseOver = function (id) {
      _this.setState({
        hoverRowId: id
      });
    };

    _this.handleMouseOut = function () {
      _this.setState({
        hoverRowId: ''
      });
    };

    _this.state = {
      hoverRowId: ''
    };
    return _this;
  }
  /**
   * Handler for when a row is clicked.
   * @param {number | string } idClicked: This is the row id.
   */


  _createClass(MultiSelectDropdown, [{
    key: "renderRowsData",

    /**
     * Render the rowsData.
     * @return {Array} - array of elements
     */
    value: function renderRowsData() {
      var _this2 = this;

      var _this$props2 = this.props,
          selectedIds = _this$props2.selectedIds,
          rowsData = _this$props2.rowsData,
          rowIdAttribute = _this$props2.rowIdAttribute,
          rowRenderer = _this$props2.rowRenderer,
          noDataMessage = _this$props2.noDataMessage;
      var rowNodes = [];
      rowsData.forEach(function (row, index) {
        var label = row.label,
            disabled = row.disabled;
        var id = row[rowIdAttribute];

        if (typeof id === 'undefined' || id === null) {
          throw new Error("row[".concat(index, "].").concat(rowIdAttribute, " is required but it is undefined"));
        }

        var isSelected = (0, _includes2.default)(selectedIds, id);
        var isHovered = _this2.state.hoverRowId === id;
        var labelNode = rowRenderer ? rowRenderer(row, isSelected, isHovered) : _react.default.createElement(_TextLabel.default, {
          type: _TextLabel.default.TEXT_LABEL_TYPE.PRIMARY
        }, label);

        var checkNode = _react.default.createElement(_Checkbox.default, {
          id: id.toString(),
          disabled: !!disabled,
          checked: isSelected,
          animation: false,
          color: isHovered ? _ThemeManager.default.getVar('white') : undefined,
          onChange: function onChange() {
            return null;
          }
        });

        var eventListeners = {};

        if (!disabled) {
          Object.assign(eventListeners, {
            onClick: function onClick() {
              return _this2.handleOnRowClick(id);
            },
            onMouseOver: function onMouseOver() {
              return _this2.handleMouseOver(id);
            },
            onMouseOut: _this2.handleMouseOut
          });
        }

        rowNodes.push(_react.default.createElement(_FlexLayout.default, _extends({
          className: "multi-select-row",
          key: id,
          alignItems: "center",
          itemSpacing: "10px"
        }, eventListeners, {
          "data-row-hover": isHovered,
          "data-disabled": !!disabled
        }), checkNode, labelNode));
      });

      if (rowNodes.length === 0) {
        rowNodes.push(_react.default.createElement(_TextLabel.default, {
          key: "nothing-message",
          className: "nothing-message"
        }, noDataMessage));
      }

      return rowNodes;
    }
  }, {
    key: "renderLoadingData",
    value: function renderLoadingData() {
      var loadingMessage = this.props.loadingMessage;
      return _react.default.createElement(_FlexLayout.default, {
        padding: "10px",
        justifyContent: "space-between",
        alignItems: "center"
      }, _react.default.createElement(_TextLabel.default, null, loadingMessage), _react.default.createElement(_Loader.default, null));
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props3 = this.props,
          className = _this$props3.className,
          loading = _this$props3.loading,
          selectedIds = _this$props3.selectedIds,
          rowsData = _this$props3.rowsData,
          rowIdAttribute = _this$props3.rowIdAttribute,
          rowRenderer = _this$props3.rowRenderer,
          onSelectedChange = _this$props3.onSelectedChange,
          noDataMessage = _this$props3.noDataMessage,
          loadingMessage = _this$props3.loadingMessage,
          props = _objectWithoutProperties(_this$props3, ["className", "loading", "selectedIds", "rowsData", "rowIdAttribute", "rowRenderer", "onSelectedChange", "noDataMessage", "loadingMessage"]);

      return _react.default.createElement(_StackingLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-multi-select-dropdown")),
        itemSpacing: "0px"
      }, props), loading ? this.renderLoadingData() : this.renderRowsData());
    }
  }]);

  return MultiSelectDropdown;
}(_react.default.Component);

exports.default = MultiSelectDropdown;
MultiSelectDropdown.defaultProps = {
  selectedIds: [],
  rowsData: [],
  rowIdAttribute: 'id',
  noDataMessage: _I18nManager.default.t('MultiSelectDropdown', 'no_data_message'),
  loadingMessage: _I18nManager.default.t('MultiSelectDropdown', 'loading_message')
};
MultiSelectDropdown.propTypes = {
  /**
   * Array of rows.  Each row is a select option.
   */
  rowsData: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Unique string/num identifier for this item.
     * Unless props.rowIdAttribute defined a different string, 'id' is required.
     */
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

    /**
     * When this item is selected this is the label used to display on
     * the top level selected items input.
     * This is also used to display in the drop down option.  If you need
     * to customize what to display for each row see pros.rowRenderer
     */
    label: _propTypes.default.string.isRequired
  })),

  /**
   * Array of strings of which rowData items are currently being
   * selected.
   */
  selectedIds: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])).isRequired,

  /**
   * The key attribute in a row item from rowsData[] to use as
   * a unique identifier.
   */
  rowIdAttribute: _propTypes.default.string,

  /**
   * Callback function to handle the change(added/removed selection)
   * of selectedIds list.<br>
   * onSelectedChange(selectedIds, added)<br>
   * @param {array} selectedIds: List of row ids that are currently being selected.<br>
   * @param {number|string} id: the id being added or removed.
   * @param {boolean} added: True if new id has been added to the selectedIds. False if
   * id has been removed from selectedIds.
   */
  onSelectedChange: _propTypes.default.func.isRequired,

  /**
   * By default the drop down options render each row option with
   * with a checkbox followed by the row.label
   * This callback allows you to customize your rendering of row data.<br>
   * rowRenderer(rowData, isSelected, isHover)<br>
   * @param {object} rowData: This is the data for the row.<br>
   * @param {boolean} isSelected: true if is marked as selected, false otherwise.<br>
   * @param {boolean} isHover: true if the mouse cursor is hovering on the row.<br>
   * @return {ReactNode} - The function should return a React node.<br>
   */
  rowRenderer: _propTypes.default.func,

  /**
   * Message to display when rowsData is empty.
   */
  noDataMessage: _propTypes.default.string,

  /**
   * To indicate that rowsData is being loaded.
   */
  loading: _propTypes.default.bool,

  /**
   * Customize the display string for when loading is set to true.
   */
  loadingMessage: _propTypes.default.string
};